import Component from '@glimmer/component';

import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { initializeVdrClient } from 'scaleflow/utils/aws-clients/s3VDRClient';
import * as Sentry from '@sentry/browser';

export default class ArtifactsTableCellSyncToKbComponent extends Component {
  @service currentUser;
  @service organisation;
  @service store;

  @tracked isSyncing = false;

  @action
  async saveToKnowledgeBase() {
    const tenant_id = this.organisation.id;
    const initiative_id = this.args.initiative.id;
    // const fileBlob = new Blob([this.args.artifact.content], {
    //   type: 'text/markdown',
    // });
    const artifactName = this.args.artifact.name.split('/').join('-'); // Replace slashes with dashes to avoid S3 key issues
    const s3Key = `${tenant_id}/${initiative_id}/Artifacts/${artifactName}.md`;
    this.isSyncing = true;
    try {
      const client = await initializeVdrClient(this.store);
      await client.uploadFileToBucket({
        body: this.args.artifact.content,
        key: s3Key,
        contentType: 'text/markdown',
      });
    } catch (err) {
      Sentry.captureException(err);
      console.log(err);
    } finally {
      this.isSyncing = false;
    }
  }
}
